module.exports = __webpack_public_path__ + "static/media/pastor-slide2.84c6672e.jpg";